// extracted by css-extract-rspack-plugin
export default {"CompanyBuiltStatusTile":"sputnik__CompanyBuiltStatusTile__vMYl6","companyBuiltStatusTile":"sputnik__CompanyBuiltStatusTile__vMYl6"};